/* Built In Imports */
import NextLink from 'next/link';

/* External Imports */
import { Box, Flex, Link, List, ListItem, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@moms/Ui/LazyLoadImageComponent';
import StructuredTextParser from '@moms/Utility/StructuredTextParser';
import { isOpenInNewTab, refineUrlDomain } from '@moms/Utility/utils';

/* Styles */
import FooterSt from '@moms/styleData/FooterSt';
/* Services */

/**
 *
 * @param {Object} footerData
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const Footer = ({
  region,
  lang,
  footerData,
  pageConfig,
  page,
  isWidgetDat,
}) => {
  // console.log(footerData, 'footerData');
  const allIsoMainMenus = footerData.allIsoMainMenus;
  return (
    <Box
      w="100%"
      as="footer"
      className="footer"
      id="footer"
      bg="#0E1016"
      pt={{ base: '2rem', md: '3rem' }}
      pb={{ base: '1rem', md: '0' }}
      px={{ base: '1rem', md: '0' }}
      borderTop="1px solid rgba(255, 255, 255, 0.20)"
    >
      {allIsoMainMenus && allIsoMainMenus.length > 0 && (
        <>
          <Box maxW={1050} px="1rem" w="100%" mx="auto">
            <Flex
              justifyContent="space-between"
              flexDir={{ base: 'column', md: 'row' }}
              gap="1rem"
            >
              {/*Logo*/}
              <Box w="auto" className={allIsoMainMenus[0]?.title}>
                <NextLink
                  href={refineUrlDomain(allIsoMainMenus[0]?.url, region, lang)}
                  passHref
                >
                  <Link
                    _hover={{ textDecor: 'none' }}
                    target={
                      isOpenInNewTab(allIsoMainMenus[0]?.url) ? '_blank' : ''
                    }
                  >
                    <LazyLoadImageComponent
                      w={{ base: '72px', md: '111px' }}
                      h={{ base: '72px', md: '111px' }}
                      src={allIsoMainMenus[0].icon.url}
                    />
                  </Link>
                </NextLink>
              </Box>
              {/*Toolkit*/}
              <Box className={allIsoMainMenus[1].title}>
                <Text {...FooterSt[lang].title}>
                  {allIsoMainMenus[1].title}
                </Text>
                {allIsoMainMenus[1].submenuItems.map((item, index) => {
                  return (
                    <Box
                      sx={{
                        a: {
                          color: 'rgba(255, 255, 255, 0.70) !important',
                        },
                        'a:hover': {
                          color: '#fff !important',
                        },
                      }}
                      {...FooterSt[lang].stText}
                    >
                      <NextLink
                        href={refineUrlDomain(item?.url, region, lang)}
                        // href={refineUrlDomain(item?.url, 'in', 'en')}
                        passHref
                      >
                        <Link
                          _hover={{ textDecor: 'none' }}
                          target={isOpenInNewTab(item?.url) ? '_blank' : ''}
                        >
                          <LazyLoadImageComponent
                            opacity="0.7"
                            _hover={{ opacity: '1' }}
                            src={item?.icon?.url}
                          />
                          <Text>{item.title}</Text>
                        </Link>
                      </NextLink>
                    </Box>
                  );
                })}
              </Box>
              {/*Contact us*/}

              <Box className={allIsoMainMenus[2].title}>
                <Text {...FooterSt[lang].title}>
                  {allIsoMainMenus[2].title}
                </Text>
                <StructuredTextParser
                  sx={{
                    a: {
                      color: 'rgba(255, 255, 255, 0.70) !important',
                    },
                    'a:hover': {
                      color: '#fff !important',
                    },
                  }}
                  {...FooterSt[lang].stText}
                  str={render(allIsoMainMenus[2].body)}
                />
              </Box>
              {/*social*/}

              <Box>
                <Text {...FooterSt[lang].title}>
                  {allIsoMainMenus[3].title}
                </Text>
                <List listStyleType="none" display="flex" gap="28px" mt="2rem">
                  {allIsoMainMenus[3]?.submenuItems.map((menu, index) => (
                    <ListItem key={index}>
                      <NextLink
                        href={refineUrlDomain(menu?.url, region, lang)}
                        passHref
                      >
                        <Link
                          _hover={{ textDecor: 'none' }}
                          target={isOpenInNewTab(menu?.url) ? '_blank' : ''}
                        >
                          <LazyLoadImageComponent
                            opacity="0.7"
                            _hover={{ opacity: '1' }}
                            src={menu?.icon?.url}
                          />
                        </Link>
                      </NextLink>
                    </ListItem>
                  ))}
                </List>
              </Box>
              {/* Download */}
              <Box>
                <Text {...FooterSt[lang].title}>
                  {allIsoMainMenus[4].title}
                </Text>
                <List listStyleType="none" mt="8px">
                  {allIsoMainMenus[4]?.submenuItems.map((menu, index) => (
                    <ListItem key={index}>
                      <NextLink
                        href={refineUrlDomain(menu?.url, region, lang)}
                        passHref
                      >
                        <Link
                          _hover={{ textDecor: 'none' }}
                          target={isOpenInNewTab(menu?.url) ? '_blank' : ''}
                        >
                          <LazyLoadImageComponent src={menu?.icon?.url} />
                        </Link>
                      </NextLink>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Flex>
          </Box>
          {/* copy right */}
          <Box
            w="100%"
            borderTop="1px solid rgba(255, 255, 255, 0.20)"
            mt={{ base: '40px', md: '2rem' }}
            pt={{ base: '20px', md: '0rem' }}
          >
            <Box maxW={1050} px="1rem" w="100%" mx="auto">
              <Flex
                flexWrap="wrap"
                justifyContent={{ base: 'flex-start', md: 'center' }}
                alignItems={{ base: 'flex-start', md: 'center' }}
                py="20px"
                flexDir={{ base: 'column', md: 'row' }}
              >
                {allIsoMainMenus[6].title && (
                  <Flex alignItems="center" mb={{ base: '24px', md: '0' }}>
                    {/* <Box display="inline-flex">
                      <LazyLoadImageComponent
                        w={25}
                        h={25}
                        mr={{ base: '16px', md: '25px' }}
                        src={`${config.imgPath}/d/46272/1686731673-isha-logo-main-menu.svg`}
                      />
                    </Box> */}
                    {/* <NextLink
                  href={refineUrlDomain(allIsoMainMenus[6].url, region, lang)}
                  target={
                    isOpenInNewTab(allIsoMainMenus[6].url) ? '_blank' : ''
                  }
                  passHref
                >
                  <Link> */}
                    <Text
                      display="inline-flex"
                      // _hover={{ color: '#fff', textDecor: 'none' }}
                      {...FooterSt[lang].privacyText}
                    >{` ${allIsoMainMenus[5].title} `}</Text>
                    {/* </Link>
                </NextLink> */}
                  </Flex>
                )}
                {allIsoMainMenus[6].title && (
                  <Box>
                    <Link
                      href={refineUrlDomain(
                        allIsoMainMenus[6].url,
                        region,
                        lang
                      )}
                      _hover={{ color: '#fff', textDecor: 'none' }}
                      target={
                        isOpenInNewTab(allIsoMainMenus[6].url) ? '_blank' : ''
                      }
                      {...FooterSt[lang].privacyText}
                    >
                      <Text display={{ base: 'none', md: 'inline-flex' }}>
                        &nbsp;{` | ${allIsoMainMenus[6].title} `}
                      </Text>
                    </Link>
                    <Link
                      href={refineUrlDomain(
                        allIsoMainMenus[6].url,
                        region,
                        lang
                      )}
                      _hover={{ color: '#fff', textDecor: 'none' }}
                      target={
                        isOpenInNewTab(allIsoMainMenus[6].url) ? '_blank' : ''
                      }
                      {...FooterSt[lang].privacyText}
                    >
                      <Text display={{ base: 'inline-flex', md: 'none' }}>
                        {` ${allIsoMainMenus[6].title} `}
                      </Text>
                    </Link>
                  </Box>
                )}{' '}
                {allIsoMainMenus[7].title && (
                  <Box>
                    <Link
                      href={refineUrlDomain(
                        allIsoMainMenus[7].url,
                        region,
                        lang
                      )}
                      _hover={{ color: '#fff', textDecor: 'none' }}
                      target={
                        isOpenInNewTab(allIsoMainMenus[7].url) ? '_blank' : ''
                      }
                      {...FooterSt[lang].privacyText}
                    >
                      <Text display={{ base: 'none', md: 'inline-flex' }}>
                        &nbsp;{` | ${allIsoMainMenus[7].title} `}
                      </Text>
                    </Link>
                    <Link
                      href={refineUrlDomain(
                        allIsoMainMenus[7].url,
                        region,
                        lang
                      )}
                      _hover={{ color: '#fff', textDecor: 'none' }}
                      target={
                        isOpenInNewTab(allIsoMainMenus[7].url) ? '_blank' : ''
                      }
                      {...FooterSt[lang].privacyText}
                    >
                      <Text display={{ base: 'inline-flex', md: 'none' }}>
                        {` ${allIsoMainMenus[7].title} `}
                      </Text>
                    </Link>
                  </Box>
                )}
              </Flex>
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
};
export default Footer;
